import { render, staticRenderFns } from "./membership-categories-list.vue?vue&type=template&id=bd23462a&scoped=true&"
import script from "./membership-categories-list.vue?vue&type=script&lang=ts&"
export * from "./membership-categories-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd23462a",
  null
  
)

export default component.exports